/* eslint-disable @typescript-eslint/camelcase */
import { Grid, makeStyles } from '@material-ui/core';
import Button from 'components/Button';
import InputAdornmentChip from 'components/InputAdornmentChip';
import { Formik } from 'formik';
import i18n from 'i18n';
import { FormStandardImageProps } from 'modules/environments/interfaces';
import React from 'react';
import schema from './schema';
import styles from './styles';

const useStyles = makeStyles(styles);

export interface Props {
  emails?: string | undefined;
  onCancel: () => void;
  onSubmit: (values: FormStandardImageProps) => void;
}

const initialValues: FormStandardImageProps = {
  notification_email: [],
};

const FormStandardImage = ({ onCancel, emails, onSubmit }: Props) => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Grid
        className={classes.container}
        data-testid={'autosky-formstandardimage'}
      >
        <Formik
          validationSchema={schema}
          initialValues={initialValues}
          onSubmit={onSubmit}
          enableReinitialize
        >
          {({ setFieldValue, submitForm }) => (
            <Grid container spacing={2}>
              <InputAdornmentChip
                gridXs={12}
                label={i18n.t('ENVIRONMENTS_PAGE.EMAIL_NOTIFICATION_IMAGE_KEY')}
                stateKey="notification_email"
                type="email"
                values={emails?.split(',') || []}
                setFieldValue={setFieldValue}
              />
              <Grid
                container
                justify="flex-end"
                className={classes.buttons}
                style={{ margin: '8px 0 0' }}
              >
                <Button id="submit-button" onClick={submitForm} submitButton>
                  {i18n.t('ENVIRONMENTS_PAGE.PUBLICATIONS_KEY')}
                </Button>
                <Button
                  variant="outlined"
                  id="cancel-button"
                  onClick={onCancel}
                >
                  {i18n.t('CANCEL_KEY')}
                </Button>
              </Grid>
            </Grid>
          )}
        </Formik>
      </Grid>
    </React.Fragment>
  );
};

export default FormStandardImage;
